<div class="m-subheader">
  <div class="mr-auto">
    <h3 class="m-subheader__title">
      {{ 'sales.statistics.client' | transloco }}
    </h3>
    <span></span>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div [hidden]="!utmList.length" id="chartdiv" class="chartdiv"></div>

          <div class="filter" *ngIf="list.length">
              Всего: {{ pagination.allItemCount }}
              <hx-enum-select class="m--margin-left-20" [(ngModel)]="params.source" enumName="SourceSystem" [enumType]="SourceSystem" [exclude]="sourceSystemExclude"
                              (selectChange)="applyFilters()"></hx-enum-select>
          </div>

          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 block-table-scroll">
            <table class="m-datatable__table" *ngIf="list.length && !isloading.rfm">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>{{ 'rfm-analysis.clientPhone' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'rfm-analysis.birthDate' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'rfm-analysis.orderAmount' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'rfm-analysis.total' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'rfm-analysis.segment' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'rfm-analysis.source' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of list"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  {{ item.phone }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.birthDate | date:'dd.MM.yyyy' }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.amount }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.total | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.segment }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  <span *ngFor="let sr of item.sources; let last = last">{{ 'from.' + sr | transloco }}<span *ngIf="!last">, </span></span>
                </td>
              </tr>
              </tbody>
            </table>

            <hx-loader [length]="list.length" [isLoading]="isloading.rfm"></hx-loader>

            <br/>
            <br/>

            <div class="m--align-center" *ngIf="list.length && !isloading.rfm && pagination.allItemCount > 0">
              <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                              [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

